import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type EVVariant = 'default' | 'questionable';

/**
 * Get the Tailwind color class for an EV value.
 * The questionable variant (a game with an open questionable player: its price depends on the viewer's marks) shows
 * yellow instead of green for positive EV.
 */
export function getEvColorClass(
  ev: number,
  variant: EVVariant = 'default'
): string {
  if (ev > 0) {
    return variant === 'questionable'
      ? 'text-yellow-600 dark:text-yellow-500'
      : 'text-green-600 dark:text-green-500';
  }
  if (ev < 0) return 'text-gray-400 dark:text-gray-500';
  return 'text-fg dark:text-fg';
}